import { render, staticRenderFns } from "@/modules/Quote/templates/quotes-list.html?vue&type=template&id=68ed4021&scoped=true&"
import script from "@/modules/Quote/scripts/quotes-list-from-dashboard.ts?vue&type=script&lang=js&"
export * from "@/modules/Quote/scripts/quotes-list-from-dashboard.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Quote/styles/quotes-list.scss?vue&type=style&index=0&id=68ed4021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed4021",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
